import { Theme } from '@/lib/util/theme';

export const NAMESPACE = 'fm';

// THEMEING
export const DEFAULT_THEME: Theme = 'light';
export const LS_KEY_THEME_PREFERENCE = `${NAMESPACE}.theme-preference`;
export const COOKIE_THEME = `${NAMESPACE}.theme`;
